import React from 'react';
import { translationKeys } from '@gik/calendar/i18n/en';
import coreTranslationKeys from '@gik/i18n/en/core';
import i18n from '@gik/i18n';
import { Button, SvgIcon, UI } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import { IAddToCalendarLinks } from '.';
import { openExternalLink } from '@gik/core/utils/browser';

export function openAddToCalendarModal(links: IAddToCalendarLinks) {
  const bem = bemBlock('add-to-calendar-modal');

  function addToGoogle() {
    openExternalLink(links.google);
  }

  function addToOutlookApple() {
    openExternalLink(links.ics);
  }

  return UI.dialog(
    <div className={bem()}>
      <Button
        className={bem('to-calendar-button')}
        variant={'default-outline'}
        onClick={() => addToGoogle()}
        prepend={<SvgIcon set={'brand-icons'} name="Google" />}
      >
        {i18n.t(translationKeys.addToGoogleCalendar)}
      </Button>
      <Button
        className={bem('to-calendar-button')}
        uppercase={false}
        variant={'default-outline'}
        onClick={() => addToOutlookApple()}
        prepend={<SvgIcon set={'brand-icons'} name="Outlook" />}
        append={<SvgIcon set={'brand-icons'} name="Apple" />}
      >
        {i18n.t(translationKeys.addToICS)}
      </Button>
    </div>,
    {
      title: i18n.t(translationKeys.addToCalendarModalTitle),
      buttons: (
        <div>
          <Button variant={'default-dark'} onClick={() => UI.closeDialog()}>
            {i18n.t(coreTranslationKeys.core.close)}
          </Button>
        </div>
      ),
    }
  );
}
